import React from "react";
import EmptyStateWrapper from "../../../../../shared/EmptyStateWrapper";

export const LogSidePanelUnauthorized = () => (
  <div className="flex h-full justify-center mt-10">
    <EmptyStateWrapper title="You must be an admin or developer, or Support to view Logs" />
  </div>
);
